import { _ as e } from "./extends-093996c9.js";
import c from "react";

var t = function t(_t) {
  var h = _t.dark,
      a = void 0 === h ? "#000000" : h,
      r = _t.light,
      l = void 0 === r ? "#ffffff" : r,
      p = _t.red,
      V = void 0 === p ? "#AF0F14" : p,
      n = _t.schema,
      v = {
    isotypebackground: a,
    isotypeletter: V,
    letters: a
  };
  return "light" === (void 0 === n ? "common" : n) && (v.isotypebackground = l, v.isotypeletter = V, v.letters = l), c.createElement("svg", e({
    x: "0px",
    y: "0px",
    viewBox: "0 0 559.1 55.6"
  }, _t), c.createElement("g", null, c.createElement("path", {
    fill: v.isotypeletter,
    d: "M0,1.3h28.6c9.5,0,15.5,6.6,15.5,14.6c0,6.2-2.5,10.9-8.4,13.3v0.1c5.7,1.6,7.4,7,7.7,12.4 c0.2,3.3,0.1,9.7,2.2,12.6H34c-1.3-3.3-1.3-8.5-1.9-12.7c-0.8-5.6-3-8-8.8-8H11.7v20.7H0V1.3z M11.7,25.3h12.8c5.3,0,8-2.2,8-7.6 c0-5.1-2.7-7.4-8-7.4H11.7V25.3z"
  }), c.createElement("path", {
    fill: v.isotypeletter,
    d: "M61.2,37.7c0.3,6.8,3.5,9.7,9.4,9.7c4.2,0,7.7-2.6,8.3-5h9.3c-3,9.1-9.3,12.9-18,12.9 c-12.1,0-19.6-8.3-19.6-20.2c0-11.5,8-20.3,19.6-20.3c13.1,0,19.5,11,18.7,22.8H61.2z M78.4,31c-1-5.4-3.3-8.2-8.4-8.2 c-6.8,0-8.5,5.2-8.8,8.2H78.4z"
  }), c.createElement("path", {
    fill: v.isotypeletter,
    d: "M107.4,28H95.7V16.6h11.7V28z M95.7,42.9h11.7v11.4H95.7V42.9z"
  }), c.createElement("g", {
    fill: v.letters
  }, c.createElement("path", {
    d: "M152.3,19.1c-0.8-5.3-5.9-9.3-11.6-9.3c-10.5,0-14.4,8.9-14.4,18.2c0,8.8,3.9,17.8,14.4,17.8c7.1,0,11.1-4.8,12-11.9h11.3 c-1.2,13.3-10.3,21.7-23.3,21.7c-16.3,0-26.1-12.3-26.1-27.6c0-15.8,9.7-28,26.1-28c11.6,0,21.5,6.8,22.9,19.1H152.3z"
  }), c.createElement("path", {
    d: "M189.6,14.9c12.1,0,19.9,8,19.9,20.3c0,12.2-7.8,20.2-19.9,20.2c-12,0-19.8-8-19.8-20.2C169.7,22.9,177.5,14.9,189.6,14.9z M189.6,47.4c7.2,0,9.4-6.1,9.4-12.3c0-6.2-2.2-12.3-9.4-12.3c-7.1,0-9.3,6.2-9.3,12.3C180.3,41.3,182.4,47.4,189.6,47.4z"
  }), c.createElement("path", {
    d: "M216.3,15.9h10v5.4h0.2c2.7-4.4,7.3-6.4,11.7-6.4c11.2,0,14,6.3,14,15.8v23.6h-10.6V32.6c0-6.3-1.8-9.4-6.8-9.4 c-5.7,0-8.2,3.2-8.2,11v20.1h-10.6V15.9z"
  }), c.createElement("path", {
    d: "M268.6,41.8c0,4.5,4,6.5,8.1,6.5c3,0,6.9-1.2,6.9-4.9c0-3.2-4.5-4.4-12-5.9c-6.2-1.4-12.2-3.4-12.2-10.3 c0-9.8,8.5-12.3,16.7-12.3c8.3,0,16.1,2.8,16.9,12.3h-10c-0.3-4.1-3.4-5.2-7.2-5.2c-2.4,0-5.9,0.4-5.9,3.6c0,3.8,6,4.3,12,5.7 c6.2,1.4,12.2,3.6,12.2,10.8c0,10.1-8.8,13.4-17.5,13.4c-8.9,0-17.7-3.3-18.1-13.5H268.6z"
  }), c.createElement("path", {
    d: "M313.7,15.9h7.7V23h-7.7v19c0,3.6,0.9,4.5,4.5,4.5c1.2,0,2.3-0.1,3.3-0.3v8.2c-1.8,0.3-4.1,0.4-6.2,0.4 c-6.5,0-12.1-1.4-12.1-9.1V23h-6.4v-7.1h6.4V4.4h10.6V15.9z"
  }), c.createElement("path", {
    d: "M337.3,10h-10.6V1.3h10.6V10z M326.8,15.9h10.6v38.4h-10.6V15.9z"
  }), c.createElement("path", {
    d: "M359,15.9h7.7V23H359v19c0,3.6,0.9,4.5,4.5,4.5c1.2,0,2.3-0.1,3.3-0.3v8.2c-1.8,0.3-4.1,0.4-6.2,0.4 c-6.5,0-12.1-1.4-12.1-9.1V23h-6.4v-7.1h6.4V4.4H359V15.9z"
  }), c.createElement("path", {
    d: "M407.8,54.3h-10V49h-0.2c-2.7,4.4-7.3,6.4-11.7,6.4c-11.2,0-14-6.3-14-15.8V15.9h10.6v21.7c0,6.3,1.8,9.4,6.8,9.4 c5.7,0,8.2-3.2,8.2-11V15.9h10.6V54.3z"
  }), c.createElement("path", {
    d: "M442,29.4c-0.7-4.4-3.3-6.6-7.8-6.6c-6.8,0-9,6.8-9,12.5c0,5.6,2.2,12.1,8.8,12.1c5,0,7.7-3,8.4-7.8h10.2 c-1.4,10.2-8.3,15.8-18.5,15.8c-11.6,0-19.4-8.2-19.4-19.7c0-12,7.1-20.8,19.6-20.8c9.1,0,17.5,4.8,18.1,14.6H442z"
  }), c.createElement("path", {
    d: "M469.4,10h-10.6V1.3h10.6V10z M458.8,15.9h10.6v38.4h-10.6V15.9z"
  }), c.createElement("path", {
    d: "M496.3,14.9c12.1,0,19.9,8,19.9,20.3c0,12.2-7.8,20.2-19.9,20.2c-12,0-19.8-8-19.8-20.2C476.5,22.9,484.3,14.9,496.3,14.9z M496.3,47.4c7.2,0,9.4-6.1,9.4-12.3c0-6.2-2.2-12.3-9.4-12.3c-7.1,0-9.3,6.2-9.3,12.3C487.1,41.3,489.2,47.4,496.3,47.4z M499.7,10.6h-7.4L499.5,0h11.7L499.7,10.6z"
  }), c.createElement("path", {
    d: "M523.1,15.9h10v5.4h0.2c2.7-4.4,7.3-6.4,11.7-6.4c11.2,0,14,6.3,14,15.8v23.6h-10.6V32.6c0-6.3-1.8-9.4-6.8-9.4 c-5.7,0-8.2,3.2-8.2,11v20.1h-10.6V15.9z"
  }))));
};

export { t as ReConstitucion };